import {
  ADD_SIGNATURE_ERROR,
  ADD_SIGNATURE_LOADING,
  ADD_SIGNATURE_SUCCESS,
  ALL_SIGNATURE_ERROR,
  ALL_SIGNATURE_LOADING,
  ALL_SIGNATURE_SUCCESS,
  DELETE_SIGNATURE_ERROR,
  DELETE_SIGNATURE_LOADING,
  DELETE_SIGNATURE_SUCCESS,
  GET_POLICY_ERROR,
  GET_POLICY_LOADING,
  GET_POLICY_SUCCESS,
  GET_SIGNATURE_ERROR,
  GET_SIGNATURE_LOADING,
  GET_SIGNATURE_SUCCESS,
  OPEN_POLICY_ERROR,
  OPEN_POLICY_SUCCESS,
  POLICY_CONTENT_ERROR,
  POLICY_CONTENT_LOADING,
  POLICY_CONTENT_SUCCESS,
  RESET_MESSAGES,
  RESET_RESULT,
  UPDATE_POLICY_ERROR,
  UPDATE_POLICY_LOADING,
  UPDATE_POLICY_SUCCESS,
  VIEW_SIGNATURE_ERROR,
  VIEW_SIGNATURE_LOADING,
  VIEW_SIGNATURE_SUCCESS,
} from "../types";

const initialState = {
  loading: false,
  signatureLoading: false,
  signatureError: "",
  page_loading: false,
  result: [],
  pdfResult: "",
  signResult: "",
  getSignResult: "",
  signatureResult: "",
  allUserSignature: [],
  signatureDeleteMessage: "",
  signUploadMessage: "",
  signatureGetError: "",
  deleteSignatureError: "",
  openPdf: "",
  error: "",
};

const hrReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_POLICY_LOADING:
      return {
        ...state,
        loading: action.payload,
        error: "",
      };
    case GET_POLICY_SUCCESS:
      return {
        ...state,
        loading: false,
        pdfResult: action.payload,
      };
    case GET_POLICY_ERROR:
      return {
        ...state,
        loading: false,
        pdfResult: "",
        error: action.payload,
      };
    case OPEN_POLICY_SUCCESS:
      return {
        ...state,
        loading: false,
        openPdf: action.payload,
      };
    case OPEN_POLICY_ERROR:
      return {
        ...state,
        loading: false,
        openPdf: "",
        error: action.payload,
      };
    case POLICY_CONTENT_LOADING:
      return {
        ...state,
        loading: action.payload,
        error: "",
      };
    case POLICY_CONTENT_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload,
      };
    case POLICY_CONTENT_ERROR:
      return {
        ...state,
        loading: false,
        result: [],
        error: action.payload,
      };
    case UPDATE_POLICY_LOADING:
      return {
        ...state,
        loading: action.payload,
        error: "",
      };
    case UPDATE_POLICY_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload,
      };
    case UPDATE_POLICY_ERROR:
      return {
        ...state,
        loading: false,
        result: [],
        error: action.payload,
      };
    case GET_SIGNATURE_LOADING:
      return {
        ...state,
        signatureLoading: action.payload,
        signatureGetError: "",
      };
    case GET_SIGNATURE_SUCCESS:
      return {
        ...state,
        signatureLoading: false,
        getSignResult: action.payload,
      };
    case GET_SIGNATURE_ERROR:
      return {
        ...state,
        signatureLoading: false,
        getSignResult: "",
        signatureGetError: action.payload,
      };
    case ADD_SIGNATURE_LOADING:
      return {
        ...state,
        signatureLoading: action.payload,
        signatureError: "",
      };
    case ADD_SIGNATURE_SUCCESS:
      return {
        ...state,
        signatureLoading: false,
        signatureResult: action.payload,
      };
    case ADD_SIGNATURE_ERROR:
      return {
        ...state,
        signatureLoading: false,
        signatureResult: "",
        signatureError: action.payload,
      };
    case DELETE_SIGNATURE_LOADING:
      return {
        ...state,
        signatureLoading: action.payload,
        deleteSignatureError: "",
      };
    case DELETE_SIGNATURE_SUCCESS:
      return {
        ...state,
        signatureDeleteMessage: action.payload,
      };
    case DELETE_SIGNATURE_ERROR:
      return {
        ...state,
        signatureLoading: false,
        deleteSignatureError: action.payload,
      };
    case ALL_SIGNATURE_LOADING:
      return {
        ...state,
        loading: action.payload,
        error: "",
      };
    case ALL_SIGNATURE_SUCCESS:
      return {
        ...state,
        loading: false,
        allUserSignature: action.payload,
      };
    case ALL_SIGNATURE_ERROR:
      return {
        ...state,
        loading: false,
        allUserSignature: "",
        error: action.payload,
      };
    case VIEW_SIGNATURE_LOADING:
      return {
        ...state,
        page_loading: action.payload,
      };
    case VIEW_SIGNATURE_SUCCESS:
      return {
        ...state,
        signResult: action.payload,
        page_loading: false,
      };
    case VIEW_SIGNATURE_ERROR:
      return {
        ...state,
        page_loading: false,
        docError: action.payload,
      };
    case RESET_RESULT:
      return {
        ...state,
        loading: false,
        result: [],
        openPdf: "",
        error: "",
        pdfResult: "",
        signResult: "",
        signatureError: "",
        signatureResult: "",
        signatureGetError: "",
        deleteSignatureError: "",
        signatureDeleteMessage: "",
      };
    case RESET_MESSAGES:
      return {
        ...state,
        error: "",
      };

    default:
      return state;
  }
};

export default hrReducer;
